import React from "react";
import { Skeleton, Box, Typography, Button } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";

function FacebookCircularProgress({sx, props, loading = true, hasData = false, onRefresh, message = "No data available"}) {
  if (loading) {
    return (
      <Box
        sx={{
          width: "100%",
          minWidth: "150px",
          borderRadius: 2,
          p: 2,
          display: "flex",
          flexDirection: "column",
          gap: 2,
          ...sx,
        }}
        {...props}
      >
        <Skeleton variant="rounded" width="60%" height={24} animation="wave" sx={{ borderRadius: 1 }} />
        <Skeleton variant="rounded" width="40%" height={16} animation="wave" sx={{ borderRadius: 1 }} />
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Skeleton variant="rounded" width="100%" height={12} animation="wave" sx={{ borderRadius: 1 }} />
          <Skeleton variant="rounded" width="90%" height={12} animation="wave" sx={{ borderRadius: 1 }} />
          <Skeleton variant="rounded" width="80%" height={12} animation="wave" sx={{ borderRadius: 1 }} />
        </Box>
      </Box>
    );
  }

  if (!hasData && onRefresh) {
    return (
      <Box
        sx={{
          width: "100%",
          minWidth: "150px",
          borderRadius: 2,
          p: 3,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
          ...sx,
        }}
        {...props}
      >
        <Typography 
          variant="body2" 
          color="text.secondary" 
          align="center"
          sx={{ mb: 1 }}
        >
          {message}
        </Typography>
        
        <Button
          variant="outlined"
          startIcon={<RefreshIcon />}
          onClick={onRefresh}
          sx={{
            textTransform: "none",
            borderRadius: 2,
            px: 3,
            py: 1,
            borderColor: "#007bff",
            color: "#007bff",
            "&:hover": {
              borderColor: "#0056b3",
              backgroundColor: "rgba(0, 123, 255, 0.04)",
            },
          }}
        >
          Refresh Chart
        </Button>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: "100%",
        minWidth: "150px",
        borderRadius: 2,
        p: 2,
        display: "flex",
        flexDirection: "column",
        gap: 2,
        ...sx,
      }}
      {...props}
    >
      <Skeleton variant="rounded" width="60%" height={24} animation="wave" sx={{ borderRadius: 1 }} />
      <Skeleton variant="rounded" width="40%" height={16} animation="wave" sx={{ borderRadius: 1 }} />
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        <Skeleton variant="rounded" width="100%" height={12} animation="wave" sx={{ borderRadius: 1 }} />
        <Skeleton variant="rounded" width="90%" height={12} animation="wave" sx={{ borderRadius: 1 }} />
        <Skeleton variant="rounded" width="80%" height={12} animation="wave" sx={{ borderRadius: 1 }} />
      </Box>
    </Box>
  );
}

export default FacebookCircularProgress;
